/**
 * Narrow an unknown caught value (TS infers `unknown` for `catch (e)`) to a
 * user-facing string. Use in place of `catch (e: any) { ... e.message ... }`.
 */
export function errMsg(e: unknown): string {
  return e instanceof Error ? e.message : String(e);
}
